import { IOnInit, IWindowService } from "angular";

import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../../app/records/server/serverUtility";
import angular from "angular";
import { IReportGroup } from "../../../../reporting/interfaces/IReportGroup";
import { MachineConfigurationView } from "../../models/machineConfiguration";
import {
  MachineExportService,
  vsServiceName as MachineExportServiceName,
} from "../../services/machineExportService";

export class MachinesChangeViewController implements IOnInit {
  static $inject = [MachineExportServiceName];

  /* start bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: any;
  machineConfigurations!: MachineConfigurationView[];
  ChangeId: any;
  reportGroup!: IReportGroup;
  /* end binding */

  constructor(private readonly machineExportService: MachineExportService) {}

  $onInit(): void {
    this.machineConfigurations = this.resolve.machineConfigurations;
    this.ChangeId = this.resolve.ChangeId;
    this.reportGroup = this.resolve.reportGroup;
  }

  async OLGDownload() {
    await this.machineExportService.assetMatrixDownload({
      ChangeId: this.ChangeId,
    });
  }
  async SDSDownload() {
    await this.machineExportService.slotfileDownload({
      ChangeId: this.ChangeId,
    });
  }
}
